// extracted by mini-css-extract-plugin
module.exports = {"title":"Popover-title-326tA","body":"Popover-body-10Yh7","tooltipBody":"Popover-tooltipBody-lTM7Y"};